import { createApp, SetupContext } from 'vue'
import App from './App.vue'
import VCalendar from 'v-calendar'
import 'v-calendar/dist/style.css'
import { IProps } from './type'

export const mount = (target: string, options: IProps): void => {
    const app = createApp(App, options as unknown as SetupContext['attrs'])
    app.use(VCalendar)
    app.mount(target)
}
